import './Body1.css';

function Boddy(){
    return(
        <div className="layout">
            <i class="fa-solid fa-code-fork"></i>
            <h1 className='what-your'>Reinvent What Your</h1>
            <h1 className='what-your'>Business Could Be</h1>
            <button className='about-us'>ABOUT US</button>
        </div>
    )
}

export default Boddy;